// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsLinks_RefundRecebimentoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for POST /payments/links/refund_recebimento/{recebimento_id}
 *
 * Returns the recorded refund-request envelope (request id + a two-key
 * passthrough of the upstream provider's refundPayment() result). The dados
 * object is built literally in the controller, so every field is typed via
 * SubaccountsLinks_RefundRecebimentoDadosRow.
 *
 * @see controllers/subaccounts/links.php::refund_recebimento()
 */
import type { SubaccountsLinks_RefundRecebimentoDadosRow } from './SubaccountsLinks_RefundRecebimentoDadosRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type SubaccountsLinks_RefundRecebimentoResponseDados = SubaccountsLinks_RefundRecebimentoDadosRow;

export type SubaccountsLinks_RefundRecebimentoResponse = ApiResponse<SubaccountsLinks_RefundRecebimentoResponseDados>;

registerResponseContract('SubaccountsLinks_RefundRecebimentoResponse', {
  refund_requested:    { type: 'boolean', required: true },
  refund_request_id:   { type: 'number',  required: true },
  recebimento_id:      { type: 'string',  required: true },
  charge_id:           { type: 'string',  required: true },
  refund_value:        { type: 'number',  required: false },
  refund_amount_cents: { type: 'number',  required: true },
  provider_response: {
    type: 'object',
    required: true,
    fields: {
      id:     { type: 'string',  required: true },
      status: { type: 'string',  required: false },
    },
  },
  message:             { type: 'string',  required: true },
})
